<div class="input-with-counter">
  <oph-input-animate
    type="text"
    [control]="$any(metricForm().get('name'))"
    placeholder="Metric Name"
    borderRadius="12px"
    placeholderColor="var(--brown-med)"
    fontSize="18px"
    textColor="var(--off-black)"
    backgroundColor="var(--lightest)"
    fontWeight="400"
    borderColor="var(--border)"
    height="56px"
    [maxlength]="75"
  ></oph-input-animate>
  <div class="character-counter">{{ nameCharacterCount() }}/75</div>
</div>

<div class="row">
  <div class="label-container mr-10 w-100p">
    <label>Type</label>
    <tracker-detail-metric-select
      [buttonText]="typeControl().value | trackerMetricTypeDisplay"
      [options]="typeOptions"
      [disabled]="editing()"
      (optionChange)="onTypeChange($event)"
      class="type-select"
    ></tracker-detail-metric-select>
  </div>

  @if (typeControl().value === trackerMetricTypes.Select) {
    <div class="label-container">
      <label>Data</label>
      <oph-button-group
        [options]="dataOptions"
        [selectedOptionName]="metricForm().get('valueType')?.value"
        (optionClick)="onDataChange($event)"
        [buttonStyle]="{padding: '0 5px'}"
        [style]="{height: '36px', 'border-radius': '8px'}"
      ></oph-button-group>
    </div>
  }
</div>

<!-- ---------------------------------------------------------------------------- -->
<!-- -------------------------------NUMERIC METRIC------------------------------- -->
<!-- ---------------------------------------------------------------------------- -->

@if (typeControl().value === trackerMetricTypes.Numeric) {
  <div class="row">
    <div class="label-container mw-120">
      <label>Last Value</label>
      <div class="disabled-container">
        {{ metricForm().get('value')?.value | metricDisplay: metricForm().get('type')?.value }}
      </div>
    </div>

    <div class="label-container mw-120">
      <label>Current Tally</label>
      <div class="disabled-container">
        {{ metricForm().get('tally')?.value }}
      </div>
    </div>

    <div class="label-container short-label-container">
      <label>Suffix</label>
      <oph-input-orange
        [control]="$any(metricForm().get('uom'))"
        [inputStyle]="{
          height: '36px',
          'border-radius': '8px',
          'font-size': '14px',
          'font-weight': '400',
          color: 'var(--brown-med)',
          padding: '0 10px',
          'max-width': '87px'
        }"
        [orangeBorder]="false"
        placeholder="lbs"
      ></oph-input-orange>
    </div>
  </div>

  <div class="row">
    <div class="label-container">
      <label class="input-type-label">Input Type</label>
      <oph-button-group
        [options]="numericTypeOptions"
        [selectedOptionName]="metricForm().get('numericType')?.value"
        (optionClick)="onNumericTypeChange($event)"
        [buttonStyle]="{padding: '0'}"
        [style]="{'max-width': '326px', height: '36px'}"
      ></oph-button-group>
    </div>
  </div>

  <div class="row">
    <div class="label-container mw-120">
      <label>Min Value</label>
      <oph-input-orange
        [control]="$any(metricForm().get('min'))"
        [inputStyle]="{
          height: '36px',
          'border-radius': '8px',
          'font-size': '14px',
          'font-weight': '400',
          color: 'var(--brown-med)',
          padding: '0 10px'
        }"
        [orangeBorder]="false"
        [showError]="metricForm().get('min')?.invalid"
        type="number"
        (inputBlur)="onMinBlur()"
      ></oph-input-orange>
    </div>

    <div class="label-container mw-120">
      <label>Max Value</label>
      <oph-input-orange
        [control]="$any(metricForm().get('max'))"
        [inputStyle]="{
          height: '36px',
          'border-radius': '8px',
          'font-size': '14px',
          'font-weight': '400',
          color: 'var(--brown-med)',
          padding: '0 10px'
        }"
        [orangeBorder]="false"
        [showError]="metricForm().get('max')?.invalid"
        type="number"
        (inputBlur)="onMaxBlur()"
      ></oph-input-orange>
    </div>
  </div>
}

<!-- ---------------------------------------------------------------------------- -->
<!-- -------------------------------SELECT METRIC------------------------------- -->
<!-- ---------------------------------------------------------------------------- -->
@if (typeControl().value === trackerMetricTypes.Select) {
  <div class="row">
    <div class="label-container mw-160">
      <label>Last Value</label>
      <div class="disabled-container">
        {{ metricForm().get('value')?.value }}
      </div>
    </div>

    <div class="label-container mw-120">
      <label>Current Tally</label>
      <div class="disabled-container">
        {{ metricForm().get('tally')?.value }}
      </div>
    </div>

    @if (metricForm().get('valueType')?.value === 'number') {
      <div class="label-container short-label-container">
        <label>Suffix</label>
        <oph-input-orange
          [control]="$any(metricForm().get('uom'))"
          [inputStyle]="{
            height: '36px',
            'border-radius': '8px',
            'font-size': '14px',
            'font-weight': '400',
            color: 'var(--brown-med)',
            padding: '0 10px',
            'max-width': '87px'
          }"
          [orangeBorder]="false"
          placeholder="lbs"
        ></oph-input-orange>
      </div>
    }
  </div>

  <div class="options-wrapper">
    <div class="options-header">
      <div class="option-column-label">
        <label>{{ metricForm().get('valueType')?.value === 'string' ? 'List Options' : 'Numeric List Options' }}</label>
      </div>
      <div class="value-column-label">
        <label>Value</label>
        @if (metricForm().get('valueType')?.value === 'string') {
          <div class="info-button-container">
            <button class="info-button" (click)="toggleInfoTooltip()">
              <oph-icon name="info-orange" [size]="20"></oph-icon>
            </button>
            @if (infoTooltipOpen()) {
              <div class="info-tooltip">
                <div class="info-tooltip-content">Numeric values help us track and chart progress.</div>
                <oph-x-button class="info-tooltip-close" (click)="closeInfoTooltip()" [width]="16"> </oph-x-button>
              </div>
            }
          </div>
        }
      </div>
    </div>

    @for (formGroup of optionsFormArray()?.controls; track formGroup; let i = $index) {
      <div class="option-row">
        <div class="option-input-container">
          <oph-input-orange
            [control]="$any(formGroup).controls.option"
            [inputStyle]="{
              height: '36px',
              'border-radius': '8px',
              'max-width': '210px',
              'font-size': '14px',
              'font-weight': '400',
              color: 'var(--brown-med)'
            }"
            [type]="metricForm().get('valueType')?.value === 'string' ? 'text' : 'number'"
            (valueChange)="onOptionValueChange($event, i)"
          ></oph-input-orange>
        </div>

        <div class="value-input-container">
          <oph-input-orange
            [control]="$any(formGroup).controls.value"
            [inputStyle]="{
              height: '36px',
              'border-radius': '8px',
              'max-width': '300px',
              'font-size': '14px',
              'font-weight': '400',
              color: 'var(--brown-med)'
            }"
            [disabled]="metricForm().get('valueType')?.value !== 'string'"
          ></oph-input-orange>
        </div>

        @if (i > 0) {
          <div class="remove-button-container">
            <oph-x-button (click)="onRemoveOption(i)"></oph-x-button>
          </div>
        }
      </div>
    }
  </div>

  <oph-button
    color="green"
    size="small"
    [style]="{width: '125px', 'font-size': '14px', 'border-radius': '10px', 'font-weight': '500'}"
    (buttonClick)="onNewOption()"
    class="new-option-button"
  >
    <mat-icon svgIcon="plus" class="plus"></mat-icon>
    Add Option
  </oph-button>
}

<!-- ---------------------------------------------------------------------------- -->
<!-- -------------------------------BOOLEAN METRIC------------------------------- -->
<!-- ---------------------------------------------------------------------------- -->
@if (typeControl().value === trackerMetricTypes.Boolean) {
  <div class="row">
    <div class="label-container">
      <label>Last Value</label>
      <oph-button-group
        [options]="booleanOptions"
        [selectedOptionName]="getBooleanSelectedValue()"
        [disabled]="true"
        [buttonStyle]="{padding: '0 5px'}"
        [style]="{'max-width': '166px', height: '36px', 'border-radius': '8px'}"
      ></oph-button-group>
    </div>
  </div>
}

<!-- ---------------------------------------------------------------------------- -->
<!-- --------------------------------TEXT METRIC--------------------------------- -->
<!-- ---------------------------------------------------------------------------- -->
@if (typeControl().value === trackerMetricTypes.Text) {
  <div class="row">
    <div class="label-container mw-270">
      <label>Last Value</label>
      <div class="disabled-container">
        {{ metricForm().get('value')?.value }}
      </div>
    </div>
  </div>
}

<!-- ---------------------------------------------------------------------------- -->
<!-- ------------------------------DURATION METRIC------------------------------- -->
<!-- ---------------------------------------------------------------------------- -->
@if (typeControl().value === trackerMetricTypes.Duration) {
  <div class="row">
    <div class="label-container">
      <label>Duration Type</label>
      <tracker-detail-metric-select
        [buttonText]="durationTypeDisplay()"
        [options]="durationTypeDisplayOptions"
        (optionChange)="onDurationTypeDisplayChange($event)"
        class="duration-type-select"
      ></tracker-detail-metric-select>
    </div>
  </div>
}
